import { FC, Dispatch, SetStateAction, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next/pages'
import { CreateWishlistForm } from './CreateWishlistForm'
import {
    useCreateWishlist,
    WishlistInputVariable
} from '../Hooks/use-create-wishlist'
import { WishlistVisibilityEnum } from '@pylot-data/enums/WishlistVisibilityEnum'
import useIsMobile from '@lib/hooks/useIsMobile'
import { ToastType, useUI } from '@corratech/pylot-ui/context'
import { MutationUpdateWishlistArgs } from '@pylot-data/pylotschema'

export type Props = {
    show: boolean
    setShow: Dispatch<SetStateAction<boolean>>
    canRedirect?: boolean
    onCreate?: (id: number) => void
    fromWishlistSidebar?: boolean
    handleCloseWishlistSidebar?: () => void
}

export const CreateWishlist: FC<Props> = ({
    show,
    setShow,
    canRedirect = true,
    onCreate,
    fromWishlistSidebar = false,
    handleCloseWishlistSidebar
}) => {
    const { t } = useTranslation(['wishlist'])
    const router = useRouter()
    const { openToast, openCartToast } = useUI()
    const { createWishList, isLoading } = useCreateWishlist()
    const isMobile = useIsMobile()

    const closeConfirm = () => {
        setShow(false)
    }

    useEffect(() => {
        window.scrollTo({
            behavior: 'smooth',
            top: 0
        })
    }, [])

    const onSubmit = async (
        inputData: WishlistInputVariable & MutationUpdateWishlistArgs
    ) => {
        try {
            const response = await createWishList({
                ...inputData,
                visibility: WishlistVisibilityEnum.Public
            })

            if (response?.errors?.length) {
                if (fromWishlistSidebar && !isMobile) {
                    openCartToast(response?.errors[0].message, ToastType.Danger)
                } else {
                    if (handleCloseWishlistSidebar) handleCloseWishlistSidebar()
                    openToast(response?.errors[0].message, ToastType.Danger)
                }
            }

            if (response?.data?.createWishlist?.wishlist) {
                const { id, name } = response.data.createWishlist.wishlist

                // if (canRedirect) router.push(`/account/wishlist/${id}`)

                //callback on create wishlist
                if (onCreate) onCreate(Number(id))

                if (!onCreate) {
                    openToast(
                        t('wishlist|Wish list "{{ name }}" was saved.', {
                            name
                        }),
                        ToastType.Success
                    )
                }
                setShow(false)
            }
        } catch (e) {
            if (e) {
                openToast(
                    t('wishlist|Something went wrong. Please try again'),
                    ToastType.Danger
                )
            }
        }
        //close confirm box
        closeConfirm()
    }

    return (
        <CreateWishlistForm
            onSubmit={onSubmit}
            isLoading={isLoading}
            show={show}
            setShow={setShow}
            fromWishlistSidebar={fromWishlistSidebar}
        />
    )
}
